/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable no-unused-vars */
/* eslint-disable react-native/no-unused-styles */
/* eslint-disable react-native/no-inline-styles */

import React from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';

const Footer = ({ printCount }) => {
  const now = new Date();
  const formatted = now.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  return (
    <View style={styles.footer} fixed>
      <Text>
        Printed on : {formatted}
        {printCount ? `, ${printCount}x` : ''}
      </Text>
      <Text
        render={({ pageNumber, totalPages }) =>
          `Page ${pageNumber} of ${totalPages}`
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  footer: {
    position: 'absolute',
    bottom: 0,
    left: 5,
    right: 5,
    height: 20,
    borderTopWidth: 1,
    borderTopColor: '#e5e7eb',
    paddingTop: 1,
    fontSize: 8,
    color: '#6b7280',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

export default Footer;
